import { Chip } from '@mui/material';

// SeasonalMenu.jsx 에서 분리 (동작 변화 없음) — 상수·헬퍼·상태 뱃지
// ─── constants ───────────────────────────────────────────────────────────────

export const MENU_STATUS = {
  draft:  { label: '초안',   bg: '#e3f2fd', color: '#1565c0' },
  sent:   { label: '발송됨', bg: '#e8f5e9', color: '#2e7d32' },
  closed: { label: '마감',   bg: '#fce4ec', color: '#c62828' },
};

export const ORDER_STATUS = {
  pending:   { label: '신청대기', bg: '#fff8e1', color: '#f57f17' },
  confirmed: { label: '승인',     bg: '#e8f5e9', color: '#2e7d32' },
  rejected:  { label: '거절',     bg: '#fce4ec', color: '#c62828' },
};

export const emptyItem = {
  name: '',
  hot12Price: '', hot12Cal: '',
  hot16Price: '', hot16Cal: '',
  hot20Price: '', hot20Cal: '',
  iced16Price: '', iced16Cal: '',
  iced20Price: '', iced20Cal: '',
};

export const emptyMenuForm = {
  name: '', description: '', startDate: '', endDate: '',
  items: [{ ...emptyItem }],
};

// ─── helpers ─────────────────────────────────────────────────────────────────

export function fmtDate(d) {
  if (!d) return '-';
  return new Date(d).toLocaleDateString('ko-KR');
}

export function fmtPrice(n) {
  if (n === undefined || n === null || n === '') return '-';
  return `₩${Number(n).toLocaleString()}`;
}

// ─── StatusBadge ─────────────────────────────────────────────────────────────

export function StatusBadge({ map, value }) {
  const cfg = map[value] || { label: value, bg: '#eee', color: '#555' };
  return (
    <Chip
      label={cfg.label}
      size="small"
      sx={{ background: cfg.bg, color: cfg.color, fontWeight: 700, fontSize: 11 }}
    />
  );
}
